// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3Bv26","header":"PatientQuestionnaire_header__2fc2Y","info":"PatientQuestionnaire_info__2dMRX"};